module.exports = __webpack_public_path__ + "img/withdraw.59598659.png";